/**
 * aiReview.explicitClass.class 코드 목록.
 *
 * 템플릿 상세의 Sexual Content Class 행과 Templates 리스트 필터가 함께 쓴다.
 * value 는 API 가 주고받는 원본 코드이고, 화면에는 explicitClassLabel() 로
 * "매체 · 수위" 형태의 라벨을 노출한다.
 *
 * 서버는 reject category 가 rejectReasonSexualOrViolent 인 템플릿에만 이 값을
 * 채운다. 그래서 필터도 해당 카테고리를 고른 경우에만 활성화한다.
 */
export const explicitClassCodes = [
  "realExplicit",
  "realSuggestive",
  "animatedExplicit",
  "animatedSuggestive",
  "audioSexual",
  "notVisible",
];

/** 이 세부 분류가 딸려 나오는 reject category 코드. */
export const sexualRejectCategory = "rejectReasonSexualOrViolent";

/** 필터에서 "조건 없음"을 뜻하는 값. API 로는 전달하지 않는다. */
export const defaultAllExplicitClass = "all";

/**
 * 코드를 그대로 노출하면 무슨 뜻인지 읽히지 않아서 "매체 · 수위" 로 끊어 보여준다.
 * (예: "realSuggestive" -> "Real · Suggestive")
 */
const explicitClassLabels: { [code: string]: string } = {
  realExplicit: "Real · Explicit",
  realSuggestive: "Real · Suggestive",
  animatedExplicit: "Animated · Explicit",
  animatedSuggestive: "Animated · Suggestive",
  audioSexual: "Audio · Sexual",
  notVisible: "Not Visible",
};

/**
 * explicitClass 코드를 표시용 라벨로 바꾼다.
 *
 * 목록에 없는 값이 들어오면 원본을 그대로 쓴다. 서버에 분류가 추가돼도
 * 값이 빈 문자열로 사라지지 않게 하기 위함이다.
 */
export const explicitClassLabel = (code: string) =>
  explicitClassLabels[code] || code;

/** Select 컴포넌트에 넘길 옵션 목록. (맨 앞에 All) */
export const explicitClassList = [
  { label: "All", value: defaultAllExplicitClass },
  ...explicitClassCodes.map((code) => ({
    label: explicitClassLabel(code),
    value: code,
  })),
];
